/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import { useServiceCatalogService, useServiceCatalogUrl } from 'domain/shared/serviceCatalog';
import CreateServiceCatalogBreadcrumbs from 'domain/organization/serviceCatalog/createupdate/Create/Breadcrumbs';
import ServiceCatalogForm from 'domain/organization/serviceCatalog/createupdate/ServiceCatalogForm';

const CreateServiceCatalogPage = () => {
  const { create, getValidationSchema } = useServiceCatalogService();
  const { getSingleEntityUrl } = useServiceCatalogUrl();

  return (
    <CreateForm
      submitFormFunc={create}
      afterSubmit={{
        redirect: data => getSingleEntityUrl(data.id),
        message: 'You are awesome! The Service has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout breadcrumbs={<CreateServiceCatalogBreadcrumbs />} title="Create: Service">
        <ServiceCatalogForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateServiceCatalogPage;
